import styled from 'styled-components';

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.kallisto.color.border.static.borderDisabled};
`;

export const PillRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
